export default __webpack_public_path__ + "static/media/Dan_sq.0cf8fdab.jpeg";